<template>
  <div style="display:flex;justify-content:center;align-item:center">
    <el-row :gutter="20" style="width:80%; margin:auto;">
      <el-col :md="6" :xs="24">
        <search-select
          placeholder="Year"
          v-model="searchkeywords['year']"
          :selectStatus="false"
          @change="secondStatus = false"
        />
      </el-col>
      <el-col :md="6" :xs="24">
        <search-select
          placeholder="Make"
          v-model="searchkeywords['make']"
          :selectStatus="secondStatus"
          @change="thirdStatus = false"
        />
      </el-col>
      <el-col :md="6" :xs="24">
        <search-select
          :selectStatus="thirdStatus"
          placeholder="Model"
          v-model="searchkeywords['model']"
        />
      </el-col>
      <el-col :md="6" :xs="24">
        <el-button @click="beforeSearch"
          >SEARCH<i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :fullscreen="isMobile"
      top="10vh"
    >
      <el-row :gutter="8">
        <el-col
          :xs="24"
          :sm="6"
          :md="6"
          :xl="6"
          :lg="6"
          style="padding-bottom:10px;"
        >
          <search-select
            placeholder="Year"
            v-model="searchkeywords['year']"
            :selectStatus="false"
            @change="secondStatus = false"
          />
          <search-select
            placeholder="Make"
            v-model="searchkeywords['make']"
            :selectStatus="secondStatus"
            @change="thirdStatus = false"
          />
          <search-select
            placeholder="Model"
            v-model="searchkeywords['model']"
            :selectStatus="thirdStatus"
          />
          <el-button @click="dialogVisible = true"
            >SEARCH <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </el-col>
        <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
          <el-tabs v-model="activeName" :stretch="false">
            <el-tab-pane label="w/25W HID headlamps" name="first">
              <showcase />
            </el-tab-pane>
            <el-tab-pane label="w/25W headlamps" name="second">
              <card />
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
// import { getStatistics } from "@/api/table";
import card from "@/components/card";
import showcase from "@/components/showcase";
import searchSelect from "@/components/searchSelect";
import { Message } from "element-ui";
export default {
  name: "searchIndex",
  props: {
    msg: String
  },
  components: { card, showcase, searchSelect },
  data() {
    return {
      searchkeywords: {
        year: "",
        make: "",
        model: ""
      },
      value: "",
      dialogVisible: false,
      activeName: "first",
      isMobile: false,
      secondStatus: true,
      thirdStatus: true
    };
  },
  created() {
    // 如果显示设备为手机，dialog需要全屏显示
    this.fullScreen();
    // created之后，需要获取年份数据
    // console.log(innerWidth);
  },
  mounted() {
    window.onresize = () => {
      this.fullScreen();
    };
  },
  methods: {
    handleClick() {
      if (
        !this.searchkeywords["year"] ||
        !this.searchkeywords["model"] ||
        !this.searchkeywords["make"]
      ) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000
        });
        return;
      }
      // getStatistics();
    },
    handleClose() {
      // console.log("closed");
    },
    setYear(v) {
      this.searchkeywords["year"] = v;
    },
    setMake(v) {
      this.searchkeywords["make"] = v;
    },
    setModel(v) {
      this.searchkeywords["model"] = v;
    },
    beforeSearch() {
      this.dialogVisible = true;
      this.doSearch("year");
    },
    doSearch(keyword) {
      // console.log(keyword);
      // console.log("searching", this.searchkeywords);
      keyword;
    },
    test() {
      // console.log("changed");
    },
    fullScreen() {
      if (innerWidth <= 414) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.el-col {
  margin-bottom: 20px;
}
.el-button,
.el-select {
  width: 80%;
  font-style: italic;
  background-color: gray;
  color: red;
  border-radius: 0px;
}

.el-dialog {
  .el-row {
    .el-col {
      .el-select,
      .el-button {
        width: 80%;
        @media (max-width: 830px) {
          width: 100%;
        }
      }
    }
  }
}
</style>
